import { useTranslation } from 'react-i18next';
import { MessageCircle } from 'lucide-react';
import { CopyButton } from './CopyButton';

export interface ShareLinkProps {
  link: string;
  /** Why the person has to pass this link on themselves (e.g. no mailbox configured yet). */
  note: string;
}

/** A one-time link the user hands over in person or on WhatsApp: shown read-only, with Copy and a WhatsApp share. */
export function ShareLink({ link, note }: ShareLinkProps) {
  const { t } = useTranslation('common');
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-border-subtle bg-surface-sunken p-3">
      <p className="text-sm text-secondary">{note}</p>
      <input
        readOnly
        dir="ltr"
        aria-label={t('shareLink.label')}
        value={link}
        onFocus={(e) => e.currentTarget.select()}
        className="w-full rounded-md border border-border-subtle bg-surface px-2 py-1.5 font-mono text-xs"
      />
      <div className="flex flex-wrap gap-2">
        <CopyButton value={link} />
        <a
          className="inline-flex items-center gap-1.5 rounded-md border border-border-subtle px-3 py-1.5 text-sm font-medium hover:bg-surface"
          href={`https://wa.me/?text=${encodeURIComponent(link)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MessageCircle aria-hidden="true" className="size-4" />
          {t('shareLink.whatsapp')}
        </a>
      </div>
    </div>
  );
}
